import { getCheckoutSession } from "backend/stripe";
import { session } from 'wix-storage';
import wixLocation from 'wix-location';
import wixUsers from 'wix-users';

let publicKey = 'pk_live_usJMqkUJfxvqtJ8d4mhwQdK7'

export const VDGSA_USER = 'vdgsaUser';
export const STRIPE_SESSION = 'stripeCheckoutSession';

$w.onReady(function () {
    $w('#typeDropdown').value = $w('#typeDropdown').options[0].value
    let vdgsaUser = JSON.parse(session.getItem(VDGSA_USER))
});

export async function pay_click(event) {
    if (!checkValidform()) return
    let currentUser = wixUsers.currentUser;

    let type = $w('#typeDropdown').value
    let name = $w('#nameInput').value
    let email = $w('#emailInput').value
    let amount = $w('#amountInput').value
    let description = $w('#descriptionTextBox').value
    let originatingPage = "members.vdgsa.org/payment"

    let paymentItemName = type + ' : ' + description

    let checkoutSession = await getCheckoutSession(type, 
                                                   (Number.parseFloat(amount) * 100).toFixed(), 
                                                   paymentItemName, 
                                                   email, 
                                                   {name, paymentItemName, description, originatingPage})
    session.setItem(STRIPE_SESSION, JSON.stringify(checkoutSession))

    if (checkoutSession.id !== undefined) {
        wixLocation.to("https://hume.vdgsa.org/swp/?apiKey=" + publicKey + "&sessionID=" + checkoutSession.id)
    } else {
        console.log('Checkout Session Error')
    }
}

function checkValidform() {

    $w('#emailError').hide()
    $w('#amountError').hide()

    if (!$w("#emailInput").valid) {
        $w('#emailError').show()
    }
    if (!$w("#amountInput").valid) {
        $w('#amountError').show()
    }
    return (
        $w("#emailInput").valid &&
        $w("#amountInput").valid)

}